
import Navbar from './Navbar'
import Main from './Main'
import { Link, browserHistory, IndexRoute, BrowserRouter as Router, Route, Switch } from 'react-router-dom';

function Home() {
    return (
        <div className="App">    
        <Router browserHistory>
            <Navbar />
            <div className="adddetails">
                <Link to="/AddDetails" className="link"><div onClick="window.location.href=window.location.href" className="btn">
                    <p><strong>+</strong> Add Details</p>
                </div></Link>
            </div>
            <Main />
        </Router>
        </div>
    )
}

export default Home;